class SodiiImplementation extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-implementation-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-implementation-panel]'));
    this.mediaPanels = Array.from(this.querySelectorAll('[data-implementation-media]'));

    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
    this.addEventListener('shopify:block:select', this.handleBlockSelect);

    const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
    if (selectedTab) this.selectTab(selectedTab.dataset.implementationTab);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
    this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    this.pauseInactiveVideos();
  }

  handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const tab = event.target.closest('[data-implementation-tab]');
    if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

    this.selectTab(tab.dataset.implementationTab);
  };

  handleKeydown = (event) => {
    if (!(event.target instanceof Element)) return;

    const currentTab = event.target.closest('[data-implementation-tab]');
    if (!(currentTab instanceof HTMLButtonElement) || !this.contains(currentTab)) return;

    const currentIndex = this.tabs.indexOf(currentTab);
    let nextIndex;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    const nextTab = this.tabs[nextIndex];
    this.selectTab(nextTab.dataset.implementationTab);
    nextTab.focus();
  };

  handleBlockSelect = (event) => {
    if (!(event.target instanceof Element)) return;

    const tab = event.target.closest('[data-implementation-tab]');
    if (!(tab instanceof HTMLButtonElement)) return;

    this.selectTab(tab.dataset.implementationTab);
  };

  selectTab(index) {
    if (index === undefined) return;

    for (const tab of this.tabs) {
      const isSelected = tab.dataset.implementationTab === index;
      tab.setAttribute('aria-selected', isSelected.toString());
      tab.tabIndex = isSelected ? 0 : -1;
    }

    for (const panel of this.panels) {
      panel.hidden = panel.dataset.implementationPanel !== index;
    }

    for (const mediaPanel of this.mediaPanels) {
      const isActive = mediaPanel.dataset.implementationMedia === index;
      mediaPanel.classList.toggle('is-active', isActive);

      const video = mediaPanel.querySelector('video');
      if (!(video instanceof HTMLVideoElement)) continue;

      if (isActive && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }
  }

  pauseInactiveVideos() {
    for (const video of this.querySelectorAll('video')) {
      video.pause();
    }
  }
}

if (!customElements.get('sodii-implementation')) {
  customElements.define('sodii-implementation', SodiiImplementation);
}
